import { useEffect } from 'react';
import { PageStep } from './index';
import { getBtnProps, TransitionBtn } from 'views/components/pages/accountEstablishment/hooks';
import {
  ComfirmGroup,
  costomerInfoParam,
  depositAccountParam,
  employmentParam,
  investmentInfoParam,
  costomerInfoDispParam,
  depositAccountDispParam,
  employmentDispParam,
  investmentInfoDispParam,
} from 'views/utils/accountEstablish';
import { ButtonProps } from 'views/components/atoms/button';
import { AccountInfoUpdateRequestParam, useAccountInfoUpdateStore, SelectItem } from './useUpdatePage';
import { useChangeAccountInfoMutation, ChangeAccountInfoMutationVariables } from 'views/utils/graphql/graphql';
import { ToastMessageLevel } from 'views/components/atoms/toast';
import useOnceSubmit from 'views/utils/useOnceSubmit';

export const useUpdateConfirm = (
  setPageStep: React.Dispatch<React.SetStateAction<PageStep>>,
  setSelected: React.Dispatch<React.SetStateAction<SelectItem>>,
  setNewPhoneNumber: React.Dispatch<React.SetStateAction<string>>,
  onShowToast: (label: string, mesageLevel: ToastMessageLevel, selfCloseOnly?: boolean) => void,
) => {
  const { param, add } = useAccountInfoUpdateStore();
  const [changeAccountData, changeAccount] = useChangeAccountInfoMutation();
  const openAccountParam = useCreateParam(param);
  const comfirmGroup = useCreateDispParam(param, setPageStep, setSelected);

  const changeAccountSubmit = useOnceSubmit<void>(
    {
      onSubmit: async () => {
        await changeAccount(openAccountParam);
      },
    },
    [openAccountParam],
  );

  const nextButtonProps: ButtonProps = getBtnProps(TransitionBtn.UPDATE_APPLY, changeAccountSubmit);
  const prevButtonProps: ButtonProps = getBtnProps(TransitionBtn.PREV, () => {
    setPageStep(PageStep.UPDATE);
  });

  useEffect(() => {
    if (changeAccountData.data && (changeAccountData.error || changeAccountData.data.ChangeAccountInfo?.Code !== 0)) {
      onShowToast(
        changeAccountData.data?.ChangeAccountInfo?.Message ?? '登録情報の更新に失敗しました',
        ToastMessageLevel.Error,
      );
    } else if (changeAccountData.data?.ChangeAccountInfo?.Code === 0) {
      const message = changeAccountData.data?.ChangeAccountInfo?.WithEKYC
        ? '登録情報の更新を受け付けました。新登録内容での本人確認が必要です。登録メールアドレスに本人確認のためのURLを送付しましたので、お手続きをお願いします。'
        : '登録情報を更新しました';
      onShowToast(message, ToastMessageLevel.Info, true);
      setNewPhoneNumber('');
      setPageStep(PageStep.UPDATE);
    }
  }, [changeAccountData]);

  return {
    isUpdate: true,
    comfirmGroup,
    buttonProps: {
      nextButtonProps,
      prevButtonProps,
    },
  };
};

const useCreateParam = (param: AccountInfoUpdateRequestParam): ChangeAccountInfoMutationVariables => {
  return {
    input: {
      //お客様情報
      ...costomerInfoParam(param),
      //指定預金口座情報
      ...depositAccountParam(param),
      //お勤め先情報
      ...employmentParam(param),
      //投資情報
      ...investmentInfoParam(param),
    },
  };
};

const useCreateDispParam = (
  param: AccountInfoUpdateRequestParam,
  setPageStep: React.Dispatch<React.SetStateAction<PageStep>>,
  setSelected: React.Dispatch<React.SetStateAction<SelectItem>>,
): ComfirmGroup[] => {
  return [
    costomerInfoDispParam(
      param,
      () => {
        setSelected(SelectItem.CustomerInfo);
        setPageStep(PageStep.UPDATE);
      },
      true,
    ),
    depositAccountDispParam(param, () => {
      setSelected(SelectItem.DepositAccount);
      setPageStep(PageStep.UPDATE);
    }),
    employmentDispParam(param, () => {
      setSelected(SelectItem.Employment);
      setPageStep(PageStep.UPDATE);
    }),
    investmentInfoDispParam(param, () => {
      setSelected(SelectItem.InvestmentInfo);
      setPageStep(PageStep.UPDATE);
    }),
  ];
};
